<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  watch: {
    $route: {
      handler(to) {
        let arr =[...this.routerList];
        let flag = arr.filter(v => v.path === to.path)
        this.user_getSearchOptionUid('');
        if (to.meta.keep && flag.length === 0) {
          let res = [...arr]
          res.push({
            path:to.path,
            meta:to.meta
          })
          this.router_setList(res)
        }
      },
      deep: true,
      immediate:true
    }
  },
  computed: {
    ...mapGetters({
      routerList: 'route/routerList'

    })
  },
  methods: {
    ...mapActions({
      router_setList: 'route/router_setList',
      user_getSearchOptionUid: 'user/user_getSearchOptionUid'
    }),

  }
}
</script>

<style lang="less"></style>
